function getPayeursOrAnnonceurs(intervenants, key) {
  const intervenantsFilter = intervenants.filter((intervenant) => {
    return intervenant[key];
  });
  return intervenantsFilter.map((intervenant) => intervenant.nomCommercial).join(', ');
}

function genererRelanceOption(ligneEnAttente, ligneRelanceOption) {
  return {
    libelleProduit: ligneRelanceOption.produit.libelle,
    produitId: ligneRelanceOption.produit.id,
    anneeSemaine: ligneRelanceOption.ligneReseau.anneeSemaine,
    dateDevis: ligneRelanceOption.devisCommande.dateDevisCommande,
    devisId: ligneRelanceOption.devisCommande.id,
    codeDevis: ligneRelanceOption.devisCommande.code,
    payeur: getPayeursOrAnnonceurs(ligneRelanceOption.devisCommande.intervenants, 'payeur'),
    annonceur: getPayeursOrAnnonceurs(ligneRelanceOption.devisCommande.intervenants, 'annonceur'),
    qteFacesSouhaitees: ligneRelanceOption.ligneReseau.qteFacesSouhaitees,
    qteFacesPrevues: ligneRelanceOption.ligneReseau.qteFacesPrevues,
    commercialRelanceId: ligneRelanceOption.devisCommande.commercialId,
    commercialEnAttenteId: ligneEnAttente.devisCommande.commercialId,
  };
}

function createTabRelanceOption(lignesEnAttente, lignesRelanceOption) {
  const tabRelancesOption = [];
  lignesEnAttente.forEach((ligne) => {
    const ligneRelanceOptionFind = lignesRelanceOption.find((ligneRelanceOption) => {
      return ligneRelanceOption.produit.id === ligne.produit.id
        && ligneRelanceOption.ligneReseau.anneeSemaine === ligne.ligneReseau.anneeSemaine;
    });
    if (ligneRelanceOptionFind) {
      tabRelancesOption.push(genererRelanceOption(ligne, ligneRelanceOptionFind));
    }
  });
  return tabRelancesOption;
}

function getLignesWithCommercialId(lignes, commercialIds) {
  if (commercialIds.length === 0) return lignes;
  return lignes.filter((ligne) => {
    return commercialIds.find((id) => { return ligne.devisCommande.commercialId === id; });
  });
}

export default function getTabRelanceOption(lignesEnAttente, lignesRelanceOption, query) {
  const lignesEnAttenteTriees = getLignesWithCommercialId(
    lignesEnAttente, query.commercialRelanceurIds,
  );
  const lignesRelanceOptionTriees = getLignesWithCommercialId(
    lignesRelanceOption, query.commercialRelanceIds,
  );
  return createTabRelanceOption(lignesEnAttenteTriees, lignesRelanceOptionTriees);
}
